import Chart from 'chart.js'
import { Bar, mixins } from 'vue-chartjs'
import ChartJsPluginDataLabels from 'chartjs-plugin-datalabels'

export default {
  name: 'bar-chart',
  extends: Bar,
  mixins: [mixins.reactiveProp],
  props: {
    extraOptions: Object
  },
  data () {
    return {
      ctx: null
    }
  },
  methods: {
    handle (event) {
      var bar = this.$data._chart.getElementAtEvent(event)[0]
      if (bar) {
        this.$emit('on-receive', {
          label: bar._model.datasetLabel,
          xAxes: bar._model.label,
          color: bar._model.backgroundColor
        })
      }
    }
  },
  mounted () {
    this.$watch('chartData', (newVal, oldVal) => {
      this.extraOptions['onClick'] = this.handle
      this.extraOptions['responsive'] = true
      this.extraOptions['maintainAspectRatio'] = false
      this.renderChart(
        this.chartData,
        this.extraOptions
      )
    }, { immediate: true })
    this.addPlugin(ChartJsPluginDataLabels)
    Chart.defaults.global.plugins.datalabels.display = true
  }
}
